import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { bookFlowsActions } from 'features/bookFlows';

const useBookFlows = () => {
  const dispatch = useDispatch();
  const getBookFlow = useCallback(() => dispatch(bookFlowsActions.getBookFlow()), [dispatch]);
  const createBookFlow = useCallback(book_flow => dispatch(bookFlowsActions.createBookFlow(book_flow)), [dispatch]);
  const updateBookFlow = useCallback(book_flow => dispatch(bookFlowsActions.updateBookFlow(book_flow)), [dispatch]);
  const deleteBookFlow = useCallback(() => dispatch(bookFlowsActions.deleteBookFlow()), [dispatch]);
  const clearLocalActiveBookFlow = useCallback(() => dispatch(bookFlowsActions.clearLocalActiveBookFlow()), [dispatch]);

  return {
    getBookFlow,
    createBookFlow,
    updateBookFlow,
    deleteBookFlow,
    clearLocalActiveBookFlow
  };
};

export default useBookFlows;